<script setup>
import { useMetrics } from "@/composables/use.metrics";
import { computed, defineEmits, defineProps, ref, watch } from "vue";

const defaultVideo = "https://meta-vdnh-s3.mos.ru/static_content/firework/[video_1]_my dear.mp4";

const props = defineProps({
  firework: {
    type: [Object, null],
  },
  whom: {
    type: String,
    default: 'Мама, с Днем Победы!'
  }
});

const emits = defineEmits(["end"]);

const { eventTypes, hitType, hit } = useMetrics();
const video = ref();

function endVideoListener() {
  emits("end");
}

function handleVideoError(event) {
  console.log("video error: ", event);
}

function handleStalled(event) {
  console.log("video stalled: ", event);
}

function handleWaiting(event) {
  console.log("video waiting: ", event);
}

const droneFigure = {
  DroneMotherland: 0,
  DroneStar: 1,
  DroneFlower: 2,
};

const fireworksFigure = {
  Firework_Big06: 0,
  Firework_Big02: 1,
  Firework_Big03: 2,
  Firework_Big04: 3,
  Firework_Big05: 4,
};

const superFireworksFigure = {
  BigFountainFirework: 0,
  BigAddFirework: 1,
  BigFlowerFirework03: 2,
};

const videoMap = {
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigFountainFirework}`]: 1,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigAddFirework}`]: 2,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigFlowerFirework03}`]: 3,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigFountainFirework}`]: 4,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigAddFirework}`]: 5,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigFlowerFirework03}`]: 6,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigFountainFirework}`]: 7,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigAddFirework}`]: 8,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigFlowerFirework03}`]: 9,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigFountainFirework}`]: 10,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigAddFirework}`]: 11,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigFlowerFirework03}`]: 12,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigFountainFirework}`]: 13,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigAddFirework}`]: 14,
  [`${droneFigure.DroneMotherland}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigFlowerFirework03}`]: 15,

  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigFountainFirework}`]: 16,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigAddFirework}`]: 17,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigFlowerFirework03}`]: 18,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigFountainFirework}`]: 19,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigAddFirework}`]: 20,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigFlowerFirework03}`]: 21,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigFountainFirework}`]: 22,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigAddFirework}`]: 23,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigFlowerFirework03}`]: 24,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigFountainFirework}`]: 25,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigAddFirework}`]: 26,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigFlowerFirework03}`]: 27,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigFountainFirework}`]: 28,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigAddFirework}`]: 29,
  [`${droneFigure.DroneStar}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigFlowerFirework03}`]: 30,

  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigFountainFirework}`]: 31,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigAddFirework}`]: 32,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big06}-${superFireworksFigure.BigFlowerFirework03}`]: 33,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigFountainFirework}`]: 34,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigAddFirework}`]: 35,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big02}-${superFireworksFigure.BigFlowerFirework03}`]: 36,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigFountainFirework}`]: 37,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigAddFirework}`]: 38,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big03}-${superFireworksFigure.BigFlowerFirework03}`]: 39,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigFountainFirework}`]: 40,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigAddFirework}`]: 41,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big04}-${superFireworksFigure.BigFlowerFirework03}`]: 42,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigFountainFirework}`]: 43,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigAddFirework}`]: 44,
  [`${droneFigure.DroneFlower}-${fireworksFigure.Firework_Big05}-${superFireworksFigure.BigFlowerFirework03}`]: 45,
};

const videoSource = computed(() => {
  if (!props.firework) {
    return defaultVideo;
  }

  const { drone, saluteone, salutetwo } = props.firework;

  const key = `${drone}-${saluteone}-${salutetwo}`;
  if (!videoMap[key]) {
    console.log('default video')
    return defaultVideo;
  }


  const videoName = `[video_${videoMap[key]}]${props.whom}`;

  const videoSrc = `https://meta-vdnh-s3.mos.ru/static_content/firework/${videoName}.mp4`;

  return videoSrc;
});

watch(videoSource, (src) => {
  if (src === defaultVideo) return;

  hit(eventTypes.FIREWORK, hitType.SELECT_VIDEO, { video: src });
  localStorage.setItem("video", src);
}, { immediate: true });

watch(() => !!props.firework, (state) => {
  document.body.style.overflowY = state ? 'hidden' : 'visible';
}, { immediate: true });
</script>

<template>
  <Transition nam="fade">
    <div v-if="firework" class="firework-video__wrapper">
      <div class="firework-content">
        <button class="close" @click="endVideoListener">
          <svg class="close__img" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_7509_946)">
              <rect width="21" height="21" rx="10.5" fill="white" />
              <path d="M10.5 0C4.65 0 0 4.65 0 10.5C0 16.35 4.65 21 10.5 21C16.35 21 21 16.35 21 10.5C21 4.65 16.35 0 10.5 0ZM14.55 15.75L10.5 11.7L6.45 15.75L5.25 14.55L9.3 10.5L5.25 6.45L6.45 5.25L10.5 9.3L14.55 5.25L15.75 6.45L11.7 10.5L15.75 14.55L14.55 15.75Z" fill="#5D6C85" />
            </g>
            <defs>
              <clipPath id="clip0_7509_946">
                <rect width="21" height="21" rx="10.5" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <video
          ref="video"
          :key="videoSource"
          class="firework-video"
          preload="auto"
          autoplay
          playsinline
          webkit-playsinline
          :src="videoSource"
          @ended="endVideoListener"
          @error="handleVideoError"
          @stalled="handleStalled"
          @waiting="handleWaiting"
        />
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.firework-video__wrapper {
  position: fixed;
  inset: 0;
  z-index: 1000;
  overflow: hidden;
  display: flex;
  align-items: center;
  background: #000;
  height: 100vh;
  height: 100dvh;

  .firework-video {
    max-width: 100%;
    position: relative;
    width: 100%;
    height: 100%;
  }
}

.firework {
  &-content {
    max-width: 100%;
    height: 100%;
    width: 100%;
    margin: 0 auto;
    position: relative;
  }
}
.close {
  position: absolute;
  right: 42px;
  top: 42px;
  z-index: 1;

  @media (max-width: 1000px) {
    right: 16px;
    top: 16px;
  }
}
</style>
